module.exports = __webpack_public_path__ + "img/upload.df9efc43.svg";